const basemapDef = {
    id: "echigokyuryo_dem_with_ellipsoidal_height_v2",
    name: "地形",
    type: "basemap",
    index: 1,
    asset_id: 2299207,
    version: "2023/10/4",
}

export default basemapDef
